import React from 'react'
import { QuestionUtils } from '../../../utils/siteUtils'
import Question from './Question'
import Textbox from '../floatingText'
import { useStateValue } from '../../../hooks'

export default ({ getQuestionResponse, saveQuestionResponse, saveQuestionResponseInteger, saveQuestionResponseComment, getQuestionResponseComment, question }) => {
  const { questionLabel, questionId } = QuestionUtils.getQuestionLabelAndChoices(question)
  const [isError, setError] = useStateValue(false)
  const value = getQuestionResponse(questionId).v
  const Choices = question.maximumValue <= 4 && Array.from(Array(question.maximumValue), (x, i) => i + 1)
  return (
    <Question
      question={{ ...question, selectChoices: [] }}
      title={questionLabel}
      subtitle={question.labelExtended}
      selectedIndex={value && value - 1}
      questionChoices={Choices}
      questionId={questionId}
      saveQuestionResponse={(questionId, index) => saveQuestionResponse(questionId, index + 1)}
      errorMessage={(isError && `Must not exceed ${question.maximumValue}`) || (!!question.errorMessage && question.errorMessage)}
      {...{ saveQuestionResponseComment, getQuestionResponseComment }}>
      {!Choices && (
        <Textbox
          label={`Quantity`}
          placeholder={`Enter Quantity (Up to ${question.maximumValue})`}
          backgroundColor="white"
          type={'text'}
          unformatMask={e => {
            return e.replace ? e.replace(/[^\d]+/, '') : e
          }}
          maxLength={`${question.maximumValue}`.length || 6}
          value={value || ''}
          inputMode={'numeric'}
          pattern={'[0-9]*'}
          onChange={newValue => {
            const cleanAnswer = newValue.replace ? newValue.replace(/[^\d]|^0/, '') : newValue
            const error = cleanAnswer > question.maximumValue
            setError(error)
            saveQuestionResponseInteger(questionId, error ? value : cleanAnswer)
          }}
        />
      )}
    </Question>
  )
}
